export enum CountryId {
    NORWAY = 160,
    UK = 225,
    Others = 0
}
